import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import {
  API_ERROR,
  FETCH_ALL_BACKGROUND_MUSICS,
} from "../constants/ActionTypes";
import { apiV2, errorHandler } from "./index";

//= ===============================
// Category actions
//= ===============================

export function fetchAllBGM() {
  return function (dispatch) {
    return apiV2.get(`/background-musics`)
      .then((response) => {
        dispatch({
          type: FETCH_ALL_BACKGROUND_MUSICS,
          payload: response.data.objects || [],
        });
        return response;
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function addEditBGM(options, onSuccess) {
  return function (dispatch) {
    const data = typeof options.bgm_json === 'string' ? JSON.parse(options.bgm_json) : options.bgm_json;
    const request = data.bgm_id
      ? apiV2.put(`/background-musics/${data.bgm_id}`, data)
      : apiV2.post('/background-musics', data);

    request
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function deleteBGM(bgm_id, onSuccess) {
  return function (dispatch) {
    apiV2.delete(`/background-musics/${bgm_id}`)
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Background Music Deleted!",
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function fetchOneBGMWithRelatedContent(bgm_id) {
  return function (dispatch) {
    return apiV2.get(`/background-musics/${bgm_id}?expand=usage`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error fetching background music with related content:', error);
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}
